const TOPICS = [
  { label: '香蕉视频热门', count: '12.8万', hot: true, color: 'bg-secondary-100 text-secondary-700' },
  { label: '蜜桃视频新番', count: '9.6万', hot: true, color: 'bg-primary-100 text-primary-700' },
  { label: '西瓜视频精选', count: '8.3万', hot: false, color: 'bg-accent-100 text-accent-700' },
  { label: '樱花视频热播', count: '7.5万', hot: true, color: 'bg-primary-100 text-primary-700' },
  { label: '糖豆视频推荐', count: '6.2万', hot: false, color: 'bg-secondary-100 text-secondary-700' },
  { label: '樱桃视频新片', count: '5.9万', hot: true, color: 'bg-accent-100 text-accent-700' },
  { label: '蘑菇视频排行', count: '5.1万', hot: false, color: 'bg-secondary-100 text-secondary-700' },
  { label: '高清电影合集', count: '4.8万', hot: false, color: 'bg-background-200 text-foreground-600' },
  { label: '电视剧连播', count: '4.3万', hot: false, color: 'bg-background-200 text-foreground-600' },
  { label: '综艺热榜', count: '3.7万', hot: true, color: 'bg-primary-100 text-primary-700' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-12 md:py-16 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 text-center mb-2">
          热门话题
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-8 md:mb-10">
          发现当下最受关注的影视话题与平台热点
        </p>
        <div className="flex flex-wrap justify-center gap-3 md:gap-4">
          {TOPICS.map((topic) => (
            <a
              key={topic.label}
              href="#topics"
              onClick={(e) => e.preventDefault()}
              className={`inline-flex items-center gap-2 px-4 py-2.5 rounded-full text-sm font-medium cursor-pointer transition-all duration-200 hover:scale-105 ${topic.color}`}
            >
              {topic.hot && (
                <i className="ri-fire-line text-xs"></i>
              )}
              <span className="whitespace-nowrap">{topic.label}</span>
              <span className="text-xs opacity-70 whitespace-nowrap">{topic.count}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}